<template>
  <div class="container-fluid">
    <TopNdviAreaHeader @onTopNdviAreaFiltersChange="onStaticFiltersChange"/>
    <div class="row">
      <div data-aos="fade-up" class="col-lg-12">
        <div class="shadow-block graphs-block">
          <div class="block-header">
            <h2>Statistics</h2>
          </div>
          <data-widget v-if="widgetData" :widgetData="widgetData"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DataWidget from '../charts/DataWidget';
  import TopNdviAreaHeader from '@/components/layout/TopNdviAreaHeader';

  export default {
    name: 'StatisticPage',
    data() {
      return {
        searchKey: '',
        updateArgs: [true, true, {duration: 1000}],
        currentIndex: 0,
        widgetData: null
      };
    },
    created() {
      const params = {};
      this.onStaticFiltersChange(params);
    },
    methods: {
      onStaticFiltersChange(params) {
        this.$loading.show();
        this.axios.post('monterre/getWidgetData', params)
            .then(response => {
              this.$loading.hide();
              if (response.data.data && response.data.data) {
                this.widgetData = response.data.data;
              }
            })
            .catch(error => {
              this.$loading.hide();
              if (error.response && error.response.data.status === 400) {
                this.$toastr.error(error.response.data.message);
              }
            });
      },
    },
    components: {
      DataWidget,
      TopNdviAreaHeader
    }
  };
</script>

<style scoped>

</style>